import React from "react"
import Underline from "./Underline"

const ContactForm = () => {
  return (
    <>
      <section className="bg-gray-700 py-20">
        <h2 className="text-white text-center text-3xl lg:text-5xl mb-1">
          Contact Us
        </h2>
        <Underline />

        <section>
          <div className="mt-1 mb-4">
            <p className="text-center text-white">
              We will get back to you as soon as possible
            </p>
          </div>

          <form
            method="POST"
            className="flex flex-col items-center justify-center lg:px-40"
          >
            <input type="hidden" name="form-name" value="contact-form" />
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              required
              className="p-2 rounded-lg w-2/3"
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              required
              className="p-2 rounded-lg w-2/3 mt-3"
            />
            <input
              type="email"
              name="email"
              placeholder="Email address"
              required
              className="p-2 rounded-lg w-2/3 mt-3"
            />
            <textarea
              name="message"
              cols="30"
              rows="5"
              placeholder="Enter your message"
              required
              className="p-2 rounded-lg w-2/3 mt-3"
            ></textarea>
            <button
              type="submit"
              className="bg-green-500 rounded-lg py-2 px-6 text-white font-bold tracking-wide w-2/3 mt-3"
            >
              Submit
            </button>
          </form>
        </section>
      </section>
    </>
  )
}

export default ContactForm
